import React from 'react';
import { withRouter } from 'react-router';
import { Alert, Modal, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { PageStatus } from 'enums';
import { Show } from 'Layout';
import { SurveysAPI } from "../../API";
import { Confirmation } from "../../Shared/Confirmation";
import moment from "moment";
import { exportToExcel } from "../../Utils/ExportToExcel";
import { InFieldStats } from './InFieldStats';


class SurveyEmailScheduleDetails extends React.Component<any, any> {
    // Hey! sonarqube, Please ignore this code
    // static defaultProps = {
    //     languageId: null,
    //     hideMenu: false,
    //     onUpdate: () => null,
    // };

    constructor(props) {
        super(props);
        this.state = {
            data: null,
            status: PageStatus.None,
            error: null,
            sendNow: false,
        };
    }

    componentDidMount() {
        if (this.props.id) {
            this.fetch();
        }
    }

    fetch() {
        Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => {
                if (!this.props.id) {
                    return Promise.reject(new Error('Invalid ID'));
                }
                return SurveysAPI.getOneEmailSchedule(this.props.id, this.props.surveyId);
            })
            .then((survey) => {
                if (survey) {
                    this.setState({ data: survey, status: PageStatus.Loaded });
                }
            })
            .catch((error) => {
                this.setState({ status: PageStatus.Error, error: error.message });
            });
    }


    onDelete() {
        Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => {
                if (!this.props.id) {
                    return Promise.reject(new Error('Invalid ID'));
                }
                return SurveysAPI.deleteEmailSchedule(this.props.id, this.props.surveyId);
            })
            .then((country) => {
                this.setState({ status: PageStatus.Loaded });
                return this.props.onDelete()

            })
            .catch((error) => {
                this.setState({ status: PageStatus.Error, error: error.message });
            });
    }


    sendNow() {
        Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => {
                if (!this.props.id) {
                    return Promise.reject(new Error('Invalid ID'));
                }
                return SurveysAPI.sendInviteNow(this.props.id, this.props.surveyId);
            })
            .then((country) => {
                this.setState({ status: PageStatus.Loaded, sendNow: true });

            })
            .catch((error) => {
                this.setState({ status: PageStatus.Error, error: error.message });
            });
    }

    downloadUsers() {
        Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => {
                if (!this.state.data?.sampleId) {
                    return Promise.reject(new Error('Invalid ID'));
                }
                return SurveysAPI.downloadUsers(this.state.data?.sampleId);
            })
            .then((users) => {
                let obj = users.user?.map((user) => {
                    return {
                        userId: user.userId,
                        name: `${user.firstName} ${user.lastName}`,
                        email: user.user ? user.user.email : '',
                        sampleId: this.state.data?.sampleId,
                        surveyId: this.state.data?.surveyId,
                        schedulerId: this.state.data?.id,
                        liveLink: '',
                        testLink: ''
                    }
                })
                exportToExcel(obj, 'ScheduleSampleUsers');
                this.setState({ status: PageStatus.Loaded });

            })
            .catch((error) => {
                this.setState({ status: PageStatus.Error, error: error.message });
            });
    }


    render() {
        return (
            <Modal
                centered
                size="lg"
                backdrop="static"
                onHide={this.props.onClose}
                show
                style={{ zIndex: 1201 }}
            >
                <Modal.Header closeButton>
                    <h5 className="mb-0 mt-1">Details</h5>
                    <div
                        className="d-flex justify-content-end w-100 mr-2"
                    >
                        <button
                            type="button"
                            onClick={() => this.props.onUpdate()}
                            className="btn-sm btn-primary mr-2"
                        >
                            <FontAwesomeIcon
                                icon={['fas', 'edit']}
                                className="mr-2"
                            />
                            Update
                        </button>
                        <Show when={this.props.isUnique === true}>
                            <Confirmation onAction={() => this.downloadUsers()} body="Are you sure want to download users?">
                                <button
                                    type="button"
                                    title="Download Users"
                                    className="btn btn-green mr-1"
                                >
                                    Download Users
                                </button>
                            </Confirmation>
                        </Show>
                        <Confirmation onAction={() => this.sendNow()} body="Are you sure want to send invite?">
                            <button
                                type="button"
                                title="End the call"
                                className="btn btn-green ms-1"
                            >
                                <FontAwesomeIcon
                                    icon={['fas', 'mailbox']}
                                    className="mr-2"
                                />
                                Send Now
                            </button>
                        </Confirmation>
                        {/* Bug 6: delete icon removed from Schedule Survey details panel.
                            Deletion is handled exclusively via the left-sidebar
                            "Deletion of Projects" tab. onDelete handler retained
                            as it is still invoked programmatically by callers. */}
                    </div>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '78vh', overflow: 'auto' }}>

                    <Show when={this.state.status === PageStatus.Loading}>
                        <div className="d-flex justify-content-center w-100 p-5">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    </Show>

                    <Show when={this.state.status === PageStatus.Loaded && !!this.state.data}>
                        <div className="row mt-2">
                            <div className="col">
                                <strong>Schedule Date: </strong>
                                {moment(this.state.data?.scheduleDate).format('MM/DD/YYYY HH:mm A')}
                            </div>
                            <div className="col">
                                <strong>Schedule Type: </strong>
                                {this.state.data?.scheduleType}
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <strong>Status: </strong>
                                {this.state.data?.scheduleStatus}
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <strong>Count: </strong>
                                {this.state.data?.count > 0 ? this.state.data?.count : 'Send to all'}
                            </div>
                        </div>

                        {this.state.data?.surveyId && (
                            <div className="mt-3">
                                <InFieldStats surveyId={this.state.data.surveyId} />
                            </div>
                        )}
                        <Alert
                            variant="danger"
                            show={this.state.status === PageStatus.Error}
                        >
                            {this.state.error}
                        </Alert>
                    </Show>
                </Modal.Body>
            </Modal>
        );
    }
}

const SurveyEmailScheduleDetailsWithRouter = withRouter(SurveyEmailScheduleDetails);

export { SurveyEmailScheduleDetailsWithRouter as SurveyEmailScheduleDetails };
